import { CACHE_QUOTA_BYTES } from '../config.js';
import { listCacheMetaByLRU } from './indexed-db.js';
import { removeFromCache, estimateUsage } from './media-cache.js';
import { stableMediaCacheKey } from './media-cache-key.js';
import { logInfo, logWarn } from '../state/log-store.js';

const TARGET_RATIO = 0.8; // evict down to 80% of quota

export async function evictIfNeeded(pinnedUrls = new Set()) {
  const { usage, quota } = await estimateUsage();
  const limit = Math.min(quota || CACHE_QUOTA_BYTES, CACHE_QUOTA_BYTES);
  if (usage <= limit) return { evicted: 0, freed: 0 };

  const target = limit * TARGET_RATIO;
  const items = await listCacheMetaByLRU(); // oldest first
  let freed = 0;
  let evictedCount = 0;
  for (const item of items) {
    if (usage - freed <= target) break;
    if (pinnedUrls.has(item.url)) continue;
    try {
      await removeFromCache(item.url);
      freed += item.sizeBytes ?? 0;
      evictedCount += 1;
    } catch (err) {
      logWarn('Eviction failed', { url: item.url, error: err.message });
    }
  }
  logInfo(`Evicted ${evictedCount} items, freed ${freed} bytes`);
  return { evicted: evictedCount, freed };
}
